import { render, staticRenderFns } from "./VideoChapters.vue?vue&type=template&id=74bef778&"
import script from "./VideoChapters.vue?vue&type=script&lang=js&"
export * from "./VideoChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports